module.exports = __webpack_public_path__ + "img/banner.7f790507.png";